module.exports = __webpack_public_path__ + "static/media/BD.8426500d.svg";